import { useQuery } from '@tanstack/react-query';

import { homeSummaryQuery } from '@/shared/api/queries/home';

export function useHomeSummary() {
  return useQuery(homeSummaryQuery);
}
